import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Mail, Copy, Check } from 'lucide-react';
interface ContactPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ContactPopup({
  isOpen,
  onClose
}: ContactPopupProps) {
  const [copied, setCopied] = useState(false);
  const email = 'info@glowliftessencemx.com';
  const handleCopy = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <AnimatePresence data-id="element-1">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-2">
            {/* Modal */}
            <motion.div initial={{
          scale: 0.9,
          opacity: 0,
          y: 20
        }} animate={{
          scale: 1,
          opacity: 1,
          y: 0
        }} exit={{
          scale: 0.9,
          opacity: 0,
          y: 20
        }} onClick={e => e.stopPropagation()} className="bg-white rounded-2xl p-8 max-w-md w-full shadow-2xl relative" data-id="element-3">
              <button onClick={onClose} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors" data-id="element-4">
                <X className="w-5 h-5" data-id="element-5" />
              </button>

              <div className="text-center mb-6" data-id="element-6">
                <div className="w-16 h-16 bg-[#F0FFF4] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7">
                  <Mail className="w-8 h-8 text-[#10B981]" data-id="element-8" />
                </div>
                <h3 className="text-2xl font-bold text-[#1B5E20] mb-2" data-id="element-9">
                  Contact Us
                </h3>
                <p className="text-gray-600" data-id="element-10">
                  Have questions? We're here to help! Send us an email and we'll
                  get back to you within 24 hours.
                </p>
              </div>

              <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 flex items-center justify-between group hover:border-[#10B981] transition-colors" data-id="element-11">
                <span className="font-medium text-[#374151] select-all" data-id="element-12">
                  {email}
                </span>
                <button onClick={handleCopy} className="p-2 text-gray-400 hover:text-[#10B981] transition-colors relative" title="Copy email" data-id="element-13">
                  {copied ? <Check className="w-5 h-5 text-[#10B981]" data-id="element-14" /> : <Copy className="w-5 h-5" data-id="element-15" />}
                </button>
              </div>

              <div className="mt-6 text-center" data-id="element-16">
                <a href={`mailto:${email}`} className="inline-flex items-center justify-center w-full bg-[#10B981] text-white font-bold py-3 px-6 rounded-xl hover:bg-[#059669] transition-colors shadow-lg shadow-[#10B981]/20" data-id="element-17">
                  Open Email App
                </a>
              </div>
            </motion.div>
          </motion.div>
        </>}
    </AnimatePresence>;
}